import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const AssetsTableActions = [
  {
    id: 'preview',
    title: 'Preview Asset',
    icon: 'tabler-eye',
    color: 'primary',
    route: { name: 'apps-assets-preview-guid', paramKey: 'guid', itemKey: 'assetGUID' },
    emit: 'preview',
  },
] as const satisfies readonly TableActionSpec[]
